import "./App.css";
import HomePage from "./components/HomePage";
import { Route, Routes } from "react-router-dom";
import WarningPage from "./components/WarningPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/warning" element={<WarningPage />} />
    </Routes>
  );
}

export default App;
